import { ReactNode } from "react"

interface ButtonWrapperProps {
  children: ReactNode
  onClick?: () => void
  className?: string
}

export default function ButtonWrapper({
  children,
  onClick,
  className = "",
}: ButtonWrapperProps) {
  return (
    <button
      onClick={onClick}
      className={`
        w-[68px] h-[68px] 
        rounded-[48px] 
        pt-2 pr-4 pb-2 pl-4 
        gap-2 
        bg-[#F5F5F5] 
        opacity-100
        flex items-center justify-center
        ${className}
      `}
    >
      {children}
    </button>
  )
}
